import React from "react";
import { NavLink } from "react-router-dom";
import LanguageSelector from "../../common/LanguageSelector";
import useTranslation from "../../../i18n/useTranslation";

export default function OrgPortalHeader({ org, logo, theme }) {
    const {
        primaryColor,
        surfaceColor,
        textOnPrimary,
        textOnSurface,
        borderColor,
    } = theme;
    const {t} = useTranslation();

    return (
        <header
            style={{
                // 🔹 Topbar uses secondary color
                backgroundColor: primaryColor,
                color: textOnPrimary,
                padding: "14px 32px",
                boxShadow: "0 4px 18px rgba(0,0,0,0.45)",
            }}
        >
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: 24,
                    flexWrap: "wrap",
                }}
            >
                {/* Left: logo + org name */}
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 16,
                        minWidth: 0,
                    }}
                >
                    {logo && (<NavLink to="/">
                        <img
                            src={logo}
                            alt={org?.name}
                            style={{ height: 54, objectFit: "contain", flexShrink: 0 }}
                        />
                    </NavLink>)}
                    <h2
                        style={{
                            margin: 0,
                            fontSize: 22,
                            fontWeight: 700,
                            color: textOnPrimary,
                            display: "-webkit-box",
                            WebkitLineClamp: 2,      // limit to 2 lines
                            WebkitBoxOrient: "vertical",
                            overflow: "hidden",
                        }}
                    >
                        {org?.name}
                    </h2>
                </div>

                {/* Right: auth buttons */}
                <div
                    style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: 10,
                        alignItems: "center",
                        justifyContent: "flex-end",
                        marginLeft: "auto",
                        width: "100%",
                        maxWidth: 420,
                    }}
                >
                    {/* Language selector */}
                    <div
                        style={{
                            flex: "1 1 100%",
                            display: "flex",
                            justifyContent: "flex-end",
                        }}
                    >
                        <LanguageSelector variant="desktop" />
                    </div>
                    
                    {/* Secondary / ghost button */}
                    <NavLink
                        to="/login"
                        style={{
                            padding: "8px 16px",
                            borderRadius: 999,
                            border: `1px solid ${borderColor || surfaceColor}`,
                            backgroundColor: surfaceColor,
                            color: textOnSurface,
                            fontWeight: 500,
                            fontSize: 14,
                            textDecoration: "none",
                            whiteSpace: "nowrap",
                            flex: "1 1 auto",
                            minWidth: 120,
                            textAlign: "center",
                        }}
                    >
                        {t("auth.loginTitle")}
                    </NavLink>

                    {/* Primary CTA button */}
                    <NavLink
                        to="/register"
                        style={{
                            padding: "8px 16px",
                            borderRadius: 999,
                            backgroundColor: primaryColor,
                            border: `1px solid ${primaryColor}`,
                            color: textOnPrimary,
                            fontWeight: 600,
                            fontSize: 14,
                            textDecoration: "none",
                            whiteSpace: "nowrap",
                            boxShadow: "0 4px 14px rgba(0,0,0,0.25)",
                            flex: "1 1 auto",
                            minWidth: 120,
                            textAlign: "center",
                        }}
                    >
                        {t("auth.registerTitle")}
                    </NavLink>

                </div>
            </div>
        </header>
    );
}